<script>
import { required, ipAddress } from "vuelidate/lib/validators";
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";
import MiddleWare from "@/helpers/middlewares.js";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      popoverShow: null,
      currentData: {},
      selectedItems: [],
      // selectAll: false,
      selected2Items: [],
      // select2All: false,
      form: {
        CidrIp: "",
        Description: "",
      },
      isConfirmed: false,
      submitted: false,
      isBtnLoading: false,
      list_search: "",
      unlist_search: "",
      listDataCopy: [],
      unListDataCopy: [],
      reload: false,
    };
  },
  props: {
    listedData: { type: Array },
    unListedData: { type: Array },
    currId: { type: String },
    currName: { type: String },
    isLoading: { type: Boolean },
    loadNow: { type: Boolean },
  },
  computed: {
    allowedList() {
      return this.listedData.filter(
        (item) =>
          item.CidrIp.includes(this.list_search) ||
          item.Description.toLowerCase().includes(
            this.list_search.toLowerCase()
          )
      );
    },
    blockedList() {
      return this.unListedData.filter(
        (item) =>
          item.CidrIp.includes(this.unlist_search) ||
          item.Description.toLowerCase().includes(
            this.unlist_search.toLowerCase()
          )
      );
    },
    selectAll: {
      get() {
        return this.selectedItems.length === this.listedData.length;
      },
      set(value) {
        if (value) {
          this.selectedItems = [...this.listedData];
        } else {
          this.selectedItems = [];
        }
      },
    },
    select2All: {
      get() {
        return this.selected2Items.length === 10;
      },
      set(value) {
        if (value) {
          this.selected2Items = this.unListedData.slice(0, 10);
        } else {
          this.selected2Items = [];
        }
      },
    },
  },
  validations: {
    form: {
      CidrIp: { required, ipAddress },
      Description: { required },
    },
  },
  methods: {
    handlePopover(id) {
      if (id) {
        this.popoverShow = id;
      } else {
        this.popoverShow = null;
      }
    },
    deleteItem() {
      this.isConfirmed = true;
      let data = {
        delete_ips_list: [],
      };
      data.delete_ips_list.push(this.currentData);
      PbxService.deleteSecurityGroupItem(this.currId, data)
        .then(() => {
          MiddleWare.notification("Deleted succesfully !!", "success", 2000);
          this.isConfirmed = false;
          this.$emit("update", this.currId);
        })
        .catch((error) => {
          this.isConfirmed = false;
          errorHandler(error);
        });
    },
    moveToAllowed() {
      this.isConfirmed = true;
      let data = {
        allow_ips_list: [],
      };
      data.allow_ips_list.push(this.currentData);
      PbxService.updateSecurityGroupItem(this.currId, data)
        .then(() => {
          MiddleWare.notification(
            "Moved to allowed traffic succesfully !!",
            "success",
            2000
          );
          this.isConfirmed = false;
          this.$emit("update", this.currId);
        })
        .catch((error) => {
          this.isConfirmed = false;
          errorHandler(error);
        });
    },
    moveToBlocked() {
      this.isConfirmed = true;
      let data = {
        block_ips_list: [],
      };
      data.block_ips_list.push(this.currentData);
      PbxService.updateSecurityGroupItem(this.currId, data)
        .then(() => {
          MiddleWare.notification(
            "Moved to blocked traffic list succesfully !!",
            "success",
            2000
          );
          this.isConfirmed = false;
          this.$emit("update", this.currId);
        })
        .catch((error) => {
          this.isConfirmed = false;
          errorHandler(error);
        });
    },
    setData(data) {
      this.currentData = data;
    },
    updateSelectAll() {
      if (this.selectedItems.length === this.listedData.length) {
        this.selectAll = true;
      } else if (this.selectedItems.length === 0) {
        this.selectAll = false;
      }
    },
    updateSelect2All() {
      if (this.selected2Items.length === this.unListedData.length) {
        this.select2All = true;
      } else if (this.selected2Items.length === 0) {
        this.select2All = false;
      }
    },
    blockMultiple() {
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm deletion?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          let data = {};
          data.block_ips_list = this.selectedItems;
          return PbxService.updateSecurityGroupItem(this.currId, data)
            .then((response) => {
              if (response) {
                this.isConfirmed = false;
                // if (this.selectAll) {
                //   this.$refs.select_all.click();
                // }
                // if (this.select2All) {
                //   this.$refs.select_all_two.click();
                // }
                this.selectedItems = [];
                this.selected2Items = [];
                this.$emit("update", this.currId);
              }
              return response;
            })
            .catch((error) => {
              this.isConfirmed = false;
              errorHandler(error);
            });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isConfirmed = false;
        }
      });
    },
    deleteMultiple() {
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm deletion?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          let data = {
            delete_ips_list: [],
          };
          data.delete_ips_list = this.selectedItems;
          return PbxService.deleteSecurityGroupItem(this.currId, data)
            .then((response) => {
              if (response) {
                // if (this.selectAll) {
                //   this.$refs.select_all.click();
                // }
                // if (this.select2All) {
                //   this.$refs.select_all_two.click();
                // }
                this.selectedItems = [];
                this.selected2Items = [];
                this.$emit("update", this.currId);
              }
              this.isConfirmed = false;
              return response;
            })
            .catch((error) => {
              this.isConfirmed = false;
              errorHandler(error);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.isConfirmed = false;
        }
      });
    },
    allowMultiple() {
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm deletion?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.isConfirmed = true;
          let data = {
            allow_ips_list: [],
          };
          data.allow_ips_list = this.selected2Items;
          return PbxService.updateSecurityGroupItem(this.currId, data)
            .then((response) => {
              if (response) {
                this.isConfirmed = false;
                // if (this.selectAll) {
                //   this.$refs.select_all.click();
                // }
                // if (this.select2All) {
                //   this.$refs.select_all_two.click();
                // }
                this.selectedItems = [];
                this.selected2Items = [];
                this.$emit("update", this.currId);
              }
              return response;
            })
            .catch((error) => {
              this.isConfirmed = false;
              errorHandler(error);
            });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isConfirmed = false;
        }
      });
    },
    delete2Multiple() {
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm deletion?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.isConfirmed = true;
          let data = {
            delete_ips_list: [],
          };
          data.delete_ips_list = this.selected2Items;
          return PbxService.deleteSecurityGroupItem(this.currId, data)
            .then((response) => {
              if (response) {
                this.isConfirmed = false;
                this.selectedItems = [];
                this.selected2Items = [];
                this.$emit("update", this.currId);
                // if (this.selectAll) {
                //   this.$refs.select_all.click();
                // }
                // if (this.select2All) {
                //   this.$refs.select_all_two.click();
                // }
              }
              return response;
            })
            .catch((error) => {
              this.isConfirmed = false;
              errorHandler(error);
            });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isConfirmed = false;
        }
      });
    },
    addNewIPDetails() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          add_new_ips_list: [],
        };
        data.add_new_ips_list.push(this.form);
        PbxService.updateSecurityGroupItem(this.currId, data)
          .then((response) => {
            if (response) {
              this.$emit("update", this.currId);
              this.$bvModal.hide("ip_modal");
            }
            this.isBtnLoading = false;
          })
          .catch((error) => {
            this.isBtnLoading = false;
            errorHandler(error);
          });
      }
    },
  },
};
</script>
<template>
  <div>
    <div
      class="d-flex align-items-center justify-content-between flex-wrap mt-2"
    >
      <h4 class="mb-0">
        Security Group
        {{ "( " + this.currName + " - " + this.currId + " )" }}
      </h4>
      <b-button
        v-b-modal.ip_modal
        @click="
          () => {
            submitted = false;
            form.CidrIp = '';
            form.Description = '';
          }
        "
        variant="primary"
      >
        Add New IP
      </b-button>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6 border-right">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap gap-3 px-3 py-2 bg-primary bg-soft"
        >
          <div class="d-flex align-items-center flex-wrap gap-2">
            <div class="form-check">
              <input
                type="checkbox"
                v-model="selectAll"
                class="form-check-input sg-check-input"
                ref="select_all"
              />
            </div>
            <b-dropdown
              v-if="selectedItems.length != 0"
              text="Button text via Prop"
              toggle-tag="a"
              toggle-class="font-size-18 p-0"
              variant="primary"
            >
              <template #button-content>
                <i class="bx bx-caret-down"></i>
              </template>
              <b-dropdown-item @click="blockMultiple()">Block</b-dropdown-item>
              <!-- <b-dropdown-item @click="deleteMultiple()">Delete</b-dropdown-item> -->
            </b-dropdown>
            <h5 class="text-danger mb-0 me-2" v-if="selectedItems.length != 0">
              ({{ selectedItems.length }})
            </h5>
            <h5 class="text-primary mb-0">
              Allowed Traffic
              {{ "(" + listedData.length + ")" }}
            </h5>
          </div>
          <b-form-input
            id="allow_traffic"
            type="text"
            placeholder="Search by IP or Name"
            autocomplete="off"
            class="sg-search-input"
            v-model="list_search"
          ></b-form-input>
        </div>
        <div v-if="isLoading">
          <div class="row" v-for="no in 6" :key="no">
            <div class="col-sm-6">
              <div class="placeholder-glow p-2">
                <span class="placeholder w-100 placeholder-lg mx-0"></span>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="placeholder-glow p-2">
                <span class="placeholder w-100 placeholder-lg mx-0"></span>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="sg-card-list"></div>
            </div>
          </div>
        </div>
        <div class="sg-scrollbar" v-else>
          <div
            class="sg-card-list p-3"
            v-for="(data, index) in allowedList"
            :key="index"
          >
            <div
              class="d-flex align-items-center justify-content-between gap-2"
            >
              <div class="d-flex align-items-center gap-2">
                <div class="form-check m-0 pt-0">
                  <input
                    type="checkbox"
                    v-model="selectedItems"
                    class="form-check-input sg-check-input mt-0"
                    :value="data"
                    @change="updateSelectAll"
                    :id="'checkbox-' + index"
                  />
                </div>
                <label
                  :for="'checkbox-' + index"
                  class="text-dark mb-0 fw-bold cursor"
                >
                  {{ data.CidrIp }}
                </label>
              </div>
              <div class="d-flex align-items-center gap-2">
                <h6 class="mb-0">
                  {{ data.Description ? data.Description : "" }}
                </h6>
                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="sg-dropdown"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-18 p-0"
                  variant="white"
                  @show="setData(data)"
                  right
                >
                  <template #button-content>
                    <i class="mdi mdi-trash-can text-danger lh-1"></i>
                  </template>
                  <p class="px-3 mb-0">Confirm Deletion ?</p>
                  <hr class="my-2" />
                  <div
                    class="d-flex align-items-center justify-content-between gap-2 px-3"
                  >
                    <b-dropdown-item href="#" class="sg-popup">
                      <b-button variant="primary" size="sm">Cancel</b-button>
                    </b-dropdown-item>
                    <b-button
                      @click="deleteItem()"
                      variant="danger"
                      size="sm"
                      class="d-flex align-items-center"
                    >
                      <i
                        v-if="isConfirmed"
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                      >
                      </i>
                      Confirm
                    </b-button>
                  </div>
                </b-dropdown>
                <!-- <i class="fas fa-arrow-right text-success"></i> -->
                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="sg-dropdown"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-18 p-0"
                  variant="white"
                  @show="setData(data)"
                  right
                >
                  <template #button-content>
                    <i class="fas fa-arrow-right text-success"></i>
                  </template>
                  <p class="px-3 mb-0">Move to blocked?</p>
                  <hr class="my-2" />
                  <div
                    class="d-flex align-items-center justify-content-between gap-2 px-3"
                  >
                    <b-dropdown-item href="#" class="sg-popup">
                      <b-button variant="primary" size="sm">Cancel</b-button>
                    </b-dropdown-item>
                    <b-button
                      @click="moveToBlocked()"
                      variant="danger"
                      size="sm"
                      class="d-flex align-items-center"
                    >
                      <i
                        v-if="isConfirmed"
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                      >
                      </i>
                      Confirm
                    </b-button>
                  </div>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap gap-3 px-3 py-2 bg-danger bg-soft"
        >
          <div class="d-flex align-items-center flex-wrap gap-2">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input sg-check-input"
                v-model="select2All"
                ref="select_all_two"
              />
            </div>
            <b-dropdown
              v-if="selected2Items.length != 0"
              text="Button text via Prop"
              toggle-tag="a"
              toggle-class="font-size-18 p-0"
              variant="primary"
            >
              <template #button-content>
                <i class="bx bx-caret-down"></i>
              </template>
              <b-dropdown-item @click="allowMultiple()">Allow</b-dropdown-item>
              <!-- <b-dropdown-item @click="delete2Multiple()">Delete</b-dropdown-item> -->
            </b-dropdown>
            <h5 class="text-danger mb-0 me-2" v-if="selected2Items.length != 0">
              ({{ selected2Items.length }})
            </h5>
            <h5 class="text-danger mb-0">
              Blocked Traffic
              {{ "(" + unListedData.length + ")" }}
            </h5>
          </div>
          <b-form-input
            id="allow_traffic"
            type="text"
            placeholder="Search by IP or Name"
            autocomplete="off"
            class="sg-search-input"
            v-model="unlist_search"
          ></b-form-input>
        </div>
        <div v-if="isLoading">
          <div class="row" v-for="no in 6" :key="no">
            <div class="col-sm-6">
              <div class="placeholder-glow p-2">
                <span class="placeholder w-100 placeholder-lg mx-0"></span>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="placeholder-glow p-2">
                <span class="placeholder w-100 placeholder-lg mx-0"></span>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="sg-card-list"></div>
            </div>
          </div>
        </div>
        <div class="sg-scrollbar" v-else>
          <div
            class="sg-card-list p-3"
            v-for="(data, index) in blockedList"
            :key="data.id"
          >
            <div
              class="d-flex align-items-center justify-content-between gap-2"
            >
              <div class="d-flex align-items-center gap-2">
                <div class="form-check m-0">
                  <input
                    type="checkbox"
                    v-model="selected2Items"
                    class="form-check-input sg-check-input mt-0"
                    :value="data"
                    @change="updateSelect2All"
                    :id="'checkboxer-' + index"
                  />
                </div>
                <label
                  :for="'checkboxer-' + index"
                  class="text-dark mb-0 fw-bold cursor"
                >
                  {{ data.CidrIp }}
                </label>
              </div>
              <div class="d-flex align-items-center gap-2">
                <h6 class="mb-0">
                  {{ data.Description ? data.Description : "" }}
                </h6>
                <!-- <i
                  class="mdi mdi-trash-can text-danger lh-1 font-size-18"
                  :id="`popover-reactive-${data.CidrIp}`"
                  @click="
                    handlePopover(data.CidrIp);
                    setData(data);
                  "
                ></i> -->
                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="sg-dropdown"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-18 p-0"
                  variant="white"
                  @show="setData(data)"
                  right
                >
                  <template #button-content>
                    <i class="mdi mdi-trash-can text-danger lh-1"></i>
                  </template>
                  <p class="px-3 mb-0">Confirm Deletion ?</p>
                  <hr class="my-2" />
                  <div
                    class="d-flex align-items-center justify-content-between gap-2 px-3"
                  >
                    <b-dropdown-item href="#" class="sg-popup">
                      <b-button variant="primary" size="sm">Cancel</b-button>
                    </b-dropdown-item>
                    <b-button
                      @click="deleteItem()"
                      variant="danger"
                      size="sm"
                      class="d-flex align-items-center"
                    >
                      <i
                        v-if="isConfirmed"
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                      >
                      </i>

                      Confirm
                    </b-button>
                  </div>
                </b-dropdown>
                <!-- <i class="fas fa-arrow-left text-success"></i> -->
                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="sg-dropdown"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-18 p-0"
                  variant="white"
                  @show="setData(data)"
                  right
                >
                  <template #button-content>
                    <i class="fas fa-arrow-left text-success"></i>
                  </template>
                  <p class="px-3 mb-0">Move to allow list?</p>
                  <hr class="my-2" />
                  <div
                    class="d-flex align-items-center justify-content-between gap-2 px-3"
                  >
                    <b-dropdown-item href="#" class="sg-popup">
                      <b-button variant="primary" size="sm">Cancel</b-button>
                    </b-dropdown-item>
                    <b-button
                      @click="moveToAllowed()"
                      variant="danger"
                      size="sm"
                      class="d-flex align-items-center"
                    >
                      <i
                        v-if="isConfirmed"
                        class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                      >
                      </i>
                      Confirm
                    </b-button>
                  </div>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add IP Modal -->
    <b-modal
      id="ip_modal"
      centered
      title="Add New IP"
      title-class="font-18"
      hide-footer
    >
      <div>
        <div class="mb-3">
          <label for="">IP Address <span class="text-danger">*</span></label>
          <input
            type="text"
            v-model="form.CidrIp"
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.CidrIp.$error,
            }"
          />
          <div
            v-if="submitted && $v.form.CidrIp.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.CidrIp.required">
              IP adderess is required.
            </span>
            <span v-if="!$v.form.CidrIp.ipAddress">
              IP adderess is invalid.
            </span>
          </div>
        </div>
        <div class="mb-3">
          <label for="">Description <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            v-model="form.Description"
            :class="{
              'is-invalid': submitted && $v.form.Description.$error,
            }"
          ></textarea>
          <div
            v-if="submitted && $v.form.Description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.Description.required">
              Description is required.
            </span>
          </div>
        </div>
        <hr />
        <div class="d-flex align-items-center justify-content-end gap-3">
          <b-button
            @click="
              () => {
                this.$bvModal.hide('ip_modal');
              }
            "
            variant="danger"
          >
            Cancel
          </b-button>
          <b-button @click="addNewIPDetails()" variant="primary">
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            >
            </i>
            Confirm
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.border-right {
  border-right: 1px solid #ced4da;
}
.sg-card-list {
  border-bottom: 1px solid #ced4da;
}
.sg-check-input {
  min-width: 18px;
  min-height: 18px;
}
.sg-scrollbar {
  height: calc(100vh - 210px);
  overflow-y: auto;
}

.sg-search-input {
  width: 200px;
}
</style>

<style>
.sg-popup a {
  padding: 0px;
}
.sg-dropdown ul {
  min-width: 150px;
}
</style>
